<script setup>
import { computed } from 'vue';
import { useInstitutionStore } from '@/stores/institution';
import ExternalInstitutionTag from '@/components/cards/ExternalInstitutionTag.vue';
import CardBaseTag from '@/components/cards/CardBaseTag.vue';
import i18n from '@/utils/i18n';
import { isToday } from 'date-fns';
import { isItemNow } from '@/utils/helpers';

const institutionStore = useInstitutionStore();

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  shouldShowDate: {
    type: Boolean,
    default: true,
  },
});

const isSharedFromAnotherInstitution = computed(() => {
  return institutionStore.isExternalInstitution(props.item.institution?.id);
});

const statusText = computed(() => {
  const isNow = isItemNow(props.item.startDate, props.item.endDate);
  const isEventToday = isToday(props.item.startDate);

  if (props.item.cancelled) {
    return i18n.global.t('global.cancelled');
  }
  if (isEventToday && !isNow) {
    return i18n.global.t('global.today');
  }
  if (isNow) {
    return i18n.global.t('global.now');
  }
  return null;
});
</script>

<template>
  <div
    class="flex z-20 absolute left-5 bottom-[140px] transform translate-y-1/2"
  >
    <CardBaseTag
      v-if="shouldShowDate && statusText"
      :statusType="props.item.cancelled ? 'warning' : 'standard'"
      class="mr-2"
    >
      <p class="flex items-center uppercase h500 py-1 px-3">
        <fa-icon :icon="['fas', 'calendar']" class="size-[16px] mr-2" />
        {{ statusText }}
      </p>
    </CardBaseTag>

    <CardBaseTag v-if="isSharedFromAnotherInstitution">
      <ExternalInstitutionTag
        :title="item.institution?.name"
        :imageSource="item.institution?.logo?.source"
      />
    </CardBaseTag>
  </div>
</template>
